import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import React, { memo, useMemo } from 'react';
import './form_html.scss';
import { UncontrolledTooltip } from 'reactstrap';
import { R } from '@core/utils/r';

export type FormToggleSwitchProps = FieldProps<FormControl<boolean>> & {
  onChange?(value: boolean): void;
  noPadding?: boolean;
  container?: string;
  toggleOnLabel?: string;
  toggleOffLabel?: string;
  style?: React.CSSProperties;
  parentDivStlye?: React.CSSProperties;
  description?: string;
};

export const FormToggleSwitch = memo((props: FormToggleSwitchProps) => {
  const { formControl, fieldState, fieldConfig } = useFormField(props);
  const { toggleOnLabel = 'On', toggleOffLabel = 'Off', description } = props;
  const uid = useMemo(() => R.random(100, 10000), []);
  const fieldValue = fieldState.value || false;
  const fieldReadonly = fieldConfig.readonly || false;
  const fieldDisabled = fieldConfig.disabled || false;

  return (
    <React.Fragment>
      <div className={`custom-control custom-checkbox custom-checkbox-primary d-flex  `} style={props.parentDivStlye}>
        <div className="square-switch">
          <input
            id={formControl.uid}
            type="checkbox"
            className="custom-control-input"
            checked={fieldValue}
            onChange={event => {
              formControl.setValue(event.target.checked);
              props.onChange && props.onChange(event.target.checked);
            }}
            onFocus={() => formControl.onFocus()}
            onBlur={() => formControl.onBlur()}
            disabled={fieldDisabled}
            readOnly={fieldReadonly}
            switch="none"
          />
          <label style={props.style} htmlFor={formControl.uid} data-on-label={toggleOnLabel} data-off-label={toggleOffLabel}></label>
        </div>
        <span className="mt-1">{fieldConfig.label}</span>
        {!!props.description && (
          <span className="text-primary ml-2 hover-pointer mt-1" id={`tt-${uid}`}>
            <i className="fa fa-question-circle font-size-16" />
            <UncontrolledTooltip container={props.container} placement="top" target={`tt-${uid}`}>
              {props.description}
            </UncontrolledTooltip>
          </span>
        )}
      </div>
    </React.Fragment>
  );
});
